import request from '@/utils/request'

// 成本定价申请相关接口
export function getInfoByDocCode(docCode) {
  return request({
    url: '/api/srm-slcm/pmMatCostApply/getInfoByDocCode/' + docCode,
    method: 'get'
  })
}
